import BricksDetail from './BricksDetail';
import BricksInvestmentsNotFound from './BricksInvestmentsNotFound';
import InvalidPropertyId from './InvalidPropertyId';
import PropertyIsNotRegistered from './PropertyIsNotRegistered';
export default BricksDetail;
export { BricksInvestmentsNotFound, InvalidPropertyId, PropertyIsNotRegistered };
